import { useEffect, useState } from 'react';
import storage from '../../../hooks/useStorage/useStorage';
import { useCurrentAnnouncement } from '../../../services/modules/announcements/announcements.queries';
import { useApplicationContext } from '../../context/ApplicationContext/ApplicationContext';

export const useAnnouncementBar = () => {
  const { data } = useCurrentAnnouncement();
  const { team } = useApplicationContext();

  const teamId = team?.id ?? '';
  const [dismissedId, setDismissedId] = useState(() => storage.getDismissedAnnouncementId(teamId));

  useEffect(() => {
    setDismissedId(storage.getDismissedAnnouncementId(teamId));
  }, [teamId]);

  const announcement = data ?? null;
  const isVisible = !!announcement && announcement.id !== dismissedId;

  const dismiss = () => {
    if (!announcement) {
      return;
    }

    storage.setDismissedAnnouncementId(announcement.id, teamId);
    setDismissedId(announcement.id);
  };

  return { announcement, isVisible, dismiss };
};
